export default () => jQuery(($) => {
	$('form.search-form__form > button:disabled').attr('disabled', false);
	$('p.section-link .open').click(function () {
		// console.log('open');
		$(this).closest('.site-search__page-one__sidebar-section').addClass('open');
	});
	$('p.section-link .close').click(function () {
		// console.log('close');
		$(this).closest('.site-search__page-one__sidebar-section').removeClass('open');
		$(this).closest('.site-search__page-one__sidebar-section').find('ul').animate({
			scrollTop: $(this).offset().top
		}, 750);
	});

	function captureClick(e, myThis) {
		var ajaxUrl = $("#query-log-id").attr("data-ajax-url");
		var click = $(myThis).attr("href");
		if (ajaxUrl === undefined) {
			// the logging info is missing (probably a no-result search)
			return true;
		}

		var logAjax = ajaxUrl + '&click=' + encodeURIComponent(click);

		$.ajax(logAjax).done(function () {
			return true;
		});
	}

	// track the link clicked after a search is performed
	$(".carleton-site-search a").click(function (e) {
		captureClick(e, this);
	});

	// var $mapFrame = $('.site-search__page-one__maps #map-wrapper');
	// $('.site-search__page-one__maps .section-link span, .site-search__page-one__maps .section-link span span').click(function () {
	// 	if ($mapFrame.hasClass('fullscreen')) {
	// 		$mapFrame.removeClass('fullscreen');
	// 	} else {
	// 		$mapFrame.addClass('fullscreen');
	// 		$('.site-search__page-one__maps #map-wrapper.fullscreen').click(function () {
	// 			$mapFrame.removeClass('fullscreen');
	// 		});
	// 	}
	// });

	const params = new URLSearchParams(window.location.search);
	if (params.has('x') || params.has('y')) {
		params.delete('x');
		params.delete('y');
		const newUrl = window.location.href.replace(window.location.search, params.toString() ? `?${params.toString()}` : '');
		history.replaceState({}, document.title, newUrl);
	}
});
